import { DialogOverlay, DialogOverlayActions, DialogOverlayFooter, TextField, Paragraph, Button } from '@fs/zion-ui'
import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CommonPerson from '../../common/CommonPerson'

export default function SwitchRelationshipPersonsDialog({ relationship, onClose, onOk, ...overlay }) {
  const { t } = useTranslation()
  const [reason, setReason] = useState('')
  const focusElementRef = useRef()

  return (
    <DialogOverlay
      {...overlay}
      focusRef={focusElementRef}
      aria-labelledby="form-dialog-title"
      title={t('person.reference.confirmSwitchPersons', 'Confirm Switching Persons')}
    >
      <Paragraph size="sm">
        {t(
          'person.relationships.switchPersonsConfirmation',
          'Are you sure you want to switch persons in this relationship to following:'
        )}
      </Paragraph>
      <div>
        {t(`relationships.associations.relationshipType.${relationship.associationType}`, relationship.associationType)}
      </div>
      {relationship?.person2?.personId && (
        <CommonPerson
          details={t(
            `relationships.associations.relationshipType.${relationship.associationType}.person1`,
            relationship.associationType
          )}
          gender={relationship?.person2?.gender}
          name={relationship?.person2?.name}
          personId={relationship?.person2?.personId}
        />
      )}
      {relationship?.person1?.personId && (
        <CommonPerson
          details={t(
            `relationships.associations.relationshipType.${relationship.associationType}.person2`,
            relationship.associationType
          )}
          gender={relationship?.person1?.gender}
          name={relationship?.person1?.name}
          personId={relationship?.person1?.personId}
        />
      )}
      <TextField
        ref={focusElementRef}
        label={t('reason', 'Reason')}
        value={reason}
        onChange={(event) => setReason(event.target.value)}
      />
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button id="confirmSwitchPersonsInRelationshipBtn" onClick={() => onOk(reason)} type="submit" emphasis="high">
            {t('action.confirm', 'Confirm')}
          </Button>
          <Button id="cancelSwitchPersonsInRelationshipBtn" onClick={onClose}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
